import { LogOutButton } from "../../auth/components/LogOut"
import { useAuth } from "../../../context/AuthContext"

export default function Navbardesk() {
  const { session } = useAuth()
  const DEBUG = process.env.NODE_ENV === 'development';

  return null

  return (
    <div className="p-4 flex justify-between items-center">
      {/* {DEBUG && <h4 className="text-lg">{session?.user?.user_metadata?.email || 'Undefined :D'}</h4>} */}
      <div className="flex gap-2 items-center">
        {/* <LogOutButton className='BG-Nieve'/> */}
      </div>
    </div>
  )
}
